<template>
  <div>
    <div v-if="data">
      <div class="mb-6 lg:mb-6">
        <h1
          ref="title"
          class="max-w-[370px] lg:max-w-[552px] mx-auto text-3xl text-center lg:text-5xl lg:short:text-[38px] text-terracota-dark font-brand"
        >
          <template v-if="data.attributes.shortDescription">
            {{ data.attributes.addressLookupTitle || data.attributes.shortDescription }}
          </template>
          <template v-else>
            Where do you want your
            <i>fresh pasta</i>
            delivered?
          </template>
        </h1>
        <p v-if="data.attributes.textSection2" class="text-center text-off-black">
          {{ data.attributes.textSection2 }}
        </p>
      </div>
      <div class="mb-4 font-semibold text-center text-off-black">
        Enter your address to see what's available to you
      </div>
    </div>
    <h1
      v-if="!data"
      ref="title"
      class="max-w-[370px] lg:max-w-[552px] mx-auto text-3xl text-center lg:text-5xl lg:short:text-[38px] text-terracota-dark font-brand mb-6 lg:mb-6"
    >
      Where do you want your
      <i>fresh pasta</i>
      delivered?
    </h1>
  </div>
</template>

<script setup lang="ts">
  import useGetVoucherInfo from '@/api/queries/pensa/useGetVoucherInfo';
  import { useRoute } from 'vue-router';

  const route = useRoute();
  const voucherParam = route.query.vc as string | undefined;

  const voucher = ref(voucherParam);

  const { data } = useGetVoucherInfo(voucher);
</script>
